export default "__VITE_ASSET__Dz02eYAn__"